<template>
  <div>
    Danh sách ứng viên
  </div>
</template>

<script>
  export default {
    name: 'ListCandidates'
  }
</script>

<style lang="scss" scoped>

</style>